interface IrpcsProps {
  onNavigate: (to: string) => void;
}

export function Irpcs({ onNavigate }: IrpcsProps) {
  return (
    <>
      <p className="muted">
        International Regulations for Preventing Collisions at Sea —
        the steering and sailing rules. Each scenario animates two
        vessels approaching; you decide who is the give-way vessel
        and what action they take. Drills Rules 12–18 (sailing,
        overtaking, head-on, crossing, give-way / stand-on, vessel
        responsibilities).
      </p>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Scenarios drill</h3>
        <p className="small muted" style={{ marginBottom: 12 }}>
          A random scenario per card from the Rules 12–18 pool. Watch
          the geometry, pick the correct action, see the rule
          citation on reveal.
        </p>
        <button
          onClick={() => onNavigate("/play/irpcs/scenarios")}
          className="secondary"
        >
          Play
        </button>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Rule priorities</h3>
        <p className="small muted" style={{ marginBottom: 8 }}>
          When in doubt, Rule 18 sorts the priority of vessels
          (highest gives way last):
        </p>
        <ol className="small" style={{ paddingLeft: 18 }}>
          <li>NUC — Not Under Command</li>
          <li>RAM — Restricted in Ability to Manoeuvre</li>
          <li>Constrained by draft (Rule 28)</li>
          <li>Engaged in fishing</li>
          <li>Sailing vessel</li>
          <li>Power-driven vessel</li>
        </ol>
        <p className="small muted">
          Two power vessels crossing: stbd-bow vessel stands on. Head-on:
          both alter to stbd. Overtaking: overtaker gives way regardless.
        </p>
      </div>

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
